"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSavedResultItem2 = exports.defaultSavedResultItem1 = void 0;
var SfilterPriceGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterPriceGroup");
var ResultPageState_init_1 = require("@/pages/search/states/ResultPageState.init");
exports.defaultSavedResultItem1 = __assign(__assign({ userPropertyId: 123, available: true, currencyId: SfilterPriceGroup_1.SfilterCurrency.HKD }, ResultPageState_init_1.defaultResultItems[0]), { lat: 22.304749, lng: 114.2459917 });
exports.defaultSavedResultItem2 = __assign(__assign({ userPropertyId: 234, available: true, currencyId: SfilterPriceGroup_1.SfilterCurrency.HKD }, ResultPageState_init_1.defaultResultItems[1]), { lat: 22.3575005, lng: 114.1264619 });
